<template>
  <div class="page" id="last" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown, 'small-desktop': $parent.smallDeskTop, 'mini-desktop': $parent.miniDeskTop }">
    <div class="last-body">
      <v-container class="last-container">
        <v-row class="last-row">
          <v-col cols="12" md="5" class="last-left">
            <img class="last-ramhee" src="../assets/exercise.png" alt="ramhee" />
            <p class="last-page-title">람희의</p>
            <p class="last-page-title">다이어트 꿀팁</p>
          </v-col>
          <v-col cols="12" md="7" class="last-right">
            <div class="ramhee-trial" v-if="showLast">
              <transition name="showMockup">
              <div class="mockup-box" v-if="showMockup" >
                  <img class="mockup" src="../assets/w_mockup_400_box.png" alt="mockup" @load="readyToShowMockup"/>
              </div>
              </transition>
              <div class="msg-box" v-if="showMsgBox">
                <ul class="msgs">
                  <li class="msg" v-for="(msg, idx) in currentDialog.msgs" v-bind:key="idx">
                    <v-row v-if="idx === 0">
                      <span class="ramhee-thumb-box"><span class="ramhee-thumb"></span></span>
                      <p class="ramhee-name">람희</p>
                    </v-row>
                    <v-row v-if="currentDialogIndex !== dialogs.length">
                      <p class="ramhee-msg">{{msg}}</p>
                    </v-row>
                  </li>
                  <li class="msg" v-if="currentDialogIndex === dialogs.length">
                    <v-row class="end-msg">
                      <img src="../assets/smile.png" alt="ramhee" @load="readyToShowRamhee"/>
                      <p class="ramhee-msg" v-if="showLastMsgBox">당연하죠! 람희는 다이어트 박사니까요</p>
                      <p class="ramhee-msg" v-if="showLastMsgBox">얼른 오세요 :) 람희가 알고 있는 모든걸 알려줄게요!</p>
                    </v-row>
                  </li>
                </ul>
              </div>
              <div class="answer-box">
                <ul class="answers" v-if="(currentDialogIndex !== dialogs.length)">
                  <li class="answer" v-for="(q, idx) in currentDialog.answers" v-bind:key="idx" @click="goNextMsg(currentDialogIndex+1)">{{q}}</li>
                </ul>
                <ul class="answers" v-if="currentDialogIndex === dialogs.length">
                  <li class="answer end-answer animate__animated animate__heartBeat animate__infinite"><a id="goToSee" :href="deepLinkUrl" target="_blank">람희 만나러 가기</a></li>
                </ul>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <div class="go-store">
        <v-container>
          <v-row>
            <v-col cols="12" md="6" class="left">
              <p class="go-store-text">지금, 람희에게 다이어트 코칭을 받아보세요!</p>
            </v-col>
            <v-col cols="12" md="6" class="right">
              <a class="go-store-btn" :href="deepLinkUrl" target="_blank">시작하기</a>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <DfFooter />
  </div>
</template>

<script>
    import DfFooter from "./DfFooter";
    export default {
        name: "Last",
        props: ['isLastPageScrolled'],
        watch: {
            isLastPageScrolled: function (isCurrent) {
                if(isCurrent) {
                    this.showLast = true;
                    this.showMockup = true;
                } else {
                    this.showLast = false;
                    this.currentDialogIndex= 0;
                    this.currentDialog= this.dialogs[0];
                }
            },
            currentDialogIndex: function (newVal) {
                if(newVal === 3) {
                  this.$mixpanel.track_links('#goToSee', 'Clicked Deep Link', { 'position': 'Ramhee Tip' });
                }
            }
        },
        data: function () {
          return {
              showLast: false,
              showThisAnswer: false,
              showMockup: false,
              showMsgBox: false,
              showLastMsgBox: false,
              currentDialog: {},
              currentDialogIndex: 0,
              deepLinkUrl: 'https://dietfriends.link/C35rDyW397',
              dialogs: [{
                  msgs: ['람희가 다이어트에 관한 간단한 몇 가지 꿀팁을 알려주려고 해요', '참고로! 모든 꿀팁은 한국영양학회를 기준으로 이야기 하는거니 람희 이야기를 믿어도 좋아요!', '무슨 꿀팁이 있는지 한 번 보겠어요?'],
                  answers: ['응 알려줘!'],
              }, {
                  msgs: ['아이스크림은 너무 맛있어요! 그치만 ㅠㅠ 아이스크림은 지방과 당이 많아 칼로리가 굉장히 높아요! 다이어트 중에는 최대한 먹지 않는게 좋죠 ㅠㅠ', '그래도 람희가 알려주는대로 한다면 다이어트 중에도 먹을 수 있는 방법이 있어요!'],
                  answers: ['그게 뭐야?? 알려줘!'],
              }, {
                  msgs: ['아이스크림이 꼬옥 먹고싶다면 과일과 요거트를 간 후, 냉동고에 3~4시간 넣어 아이스크림으로 만들어 봐요! 상큼하고 건강한 맛을 즐길수 있답니다!', '하지만 요거트 아이스크림도 너무 많이먹으면 체중이 증가할 수 있으니 1~2주에 1번 정도만 먹어줘요!'],
                  answers: ['고마워! 다른 꿀팁도 있어?'],
              }],
          }
        },
        mounted() {
            this.$mixpanel.track_links('.go-store-btn', 'Clicked Deep Link', { 'position': 'Footer' });
        },
        created() {
            this.currentDialog = this.dialogs[0];
            this.currentDialogIndex = 0;
        },
        methods: {
          getThumbUrl(pic) {
            return require('../assets/'+pic)
          },
          goNextMsg(nextIndex) {
            if(nextIndex > this.dialogs.length) return false;
            if(nextIndex !== this.dialogs.length) {
              this.currentDialog = this.dialogs[nextIndex];
            }
            this.currentDialogIndex = nextIndex;
          },
          readyToShowMockup() {
              this.showMsgBox = true;
          },
          readyToShowRamhee() {
              this.showLastMsgBox = true;
          },
        },
        components: {DfFooter}
    }
</script>

<style scoped lang="scss">
  @import '../variables';
  #last.show-mobile {
    height: auto !important;
    overflow: visible !important;
    padding-top: 3rem;
    .last-body {
      height: auto !important;
      position: relative !important;
      .last-container {
        padding-bottom: 0 !important;
      }
    }
    .footer {
      position: relative !important;
      height: auto !important;
    }
    .go-store {
      position: relative !important;
      height: auto !important;
      .left, .right {
        padding: 1rem 0 !important;
      }
    }
    .last-row {
      height: auto;
    }
    .last-left {
      height: auto !important;
      .last-ramhee {
        display: none;
      }
      .last-page-title {
        padding: 0 !important;
        width: 100%;
        text-align: center;
      }
    }
    .last-right {
      height: auto !important;
      min-height: 600px !important;
      align-items: center !important;
      padding-bottom: 0 !important;

      .ramhee-trial {
        max-width: 360px !important;
      }
      .mockup-box {
        width: 100% !important;
      }
      .msg-box {
        .msgs {
          min-width: 80% !important;
          max-width: 300px !important;
        }
      }
    }
  }
  #last {
    background: $defaultBackgroundColor;
    height: 100%;

    /*animate object*/
    .showLast-enter-active {
      animation: fade-in-top .8s;
    }
    .showLast-leave-active {
      animation: fade-in-top .8s reverse;
    }

    .showMockup-enter-active {
      animation: fade-in-top .8s;
    }
    .showMockup-leave-active {
      animation: fade-in-top .8s reverse;
    }
    .go-store {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 15%;
      background: $primaryBlueColor;
      z-index: 999;

      .container {
        height: 100%;
        padding: 0;
        .row {
          height: 100%;
          padding: 0;
          .left, .right {
            padding: 0;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .go-store-text {
            margin: 0;
            font-family: $titleFont;
            font-size: 1.4em;
            color: white;
          }
          .go-store-btn {
            font-family: $titleFont;
            font-size: 1em;
            padding: 0.8rem 1.2rem;
            background: white;
            color: $primaryBlueColor;
            text-decoration: none;
            border-radius: 1rem;
            box-shadow: $basicBoxShadow;
            margin: 0;
          }
          .go-store-btn:hover {
            background: $softPinkColor;
            transition: ease-in-out 0.2s;
            color: $basicFontColor;
          }
        }
      }
    }
    .last-body {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      height: 70%;
      height: 70vh;
      width: 100%;
    }
    .last-container {
      height: 100%;
      position: relative;
      .last-row {
        position: relative;
        height: 100%;
        overflow: hidden;
        .last-left, .last-right {
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
        .last-left {
          align-items: flex-end;
          .last-page-title {
            margin: 0;
            font-size: 2.4em;
            font-family: $brandFont;
            font-style: italic;
            padding-right: 2rem;
          }
          .last-ramhee {
            width: 240px;
            height: auto;
          }
        }
        .last-right {
          align-items: flex-start;
          min-height: 600px;
          .ramhee-trial {
            position: relative;
            width: 470px;
            height: 100%;
          }
          .ramhee-trial.small-desktop {

          }
          .msg-box {
            z-index: 200;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 6rem;
            .msgs {
              padding: 0;
              width: 400px;
              height: auto;
              flex-direction: column;
              display: flex;
              justify-content: center;
              align-items: center;
              .msg {
                width: 80%;
                padding: 0;
                margin: 0;
                .ramhee-thumb-box {
                  width: 40px;
                  height: 40px;
                  background: white;
                  border-radius: 30%;
                  overflow: hidden;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: $basicBorder;
                }
                .ramhee-thumb {
                  width: 40px;
                  height: 40px;
                  background: url('../assets/smile.png') no-repeat center center;
                  background-size: 200%;
                }
                .ramhee-name {
                  font-size: 1em;
                  font-family: $basicFont;
                  color: $basicFontColor;
                  margin: 0 0 0 1rem;
                  display: flex;
                  align-items: center;
                }
                .ramhee-msg {
                  margin-left: 1rem;
                  margin-top: 8px;
                  margin-bottom: 0;
                  padding: 0.6rem 1rem;
                  background: white;
                  min-width: 50%;
                  max-width: 90%;
                  text-align: justify;
                  border-radius: 0 10px 10px 10px;
                }
                .end-msg {
                  img {
                    width: auto;
                    height: 100px;
                    margin-top: 0.5rem;
                    margin-left: 1rem;
                  }
                }
              }
            }
          }
          .answer-box {
            position: absolute;
            bottom: 20%;
            left: 0;
            right: 0;
            margin: auto;
            z-index: 999;
            display: flex;
            justify-content: center;
            align-items: center;
            .answers {
              width: 400px;
              padding: 0;
              flex-direction: column;
              display: flex;
              justify-content: center;
              align-items: center;
              .answer {
                display: inline-block;
                padding: 0.6rem 1rem;
                background: white;
                border: 1px solid $basicFontColor;
                border-radius: 16px;
                margin: 0.2rem 0.5rem;
                cursor: pointer;
              }
              .answer.end-answer {
                border: 1px solid $primaryBlueColor;
                a {
                  margin: 0;
                  padding: 0;
                  color: $primaryBlueColor;
                  text-decoration: none;
                }
              }
              .answer:hover {
                background: $primaryBlueColor;
                color: white;
                transition: ease-in-out 0.1s;
              }
              .end-answer:hover {
                background: $primaryBlueColor;
                color: white;
                a {
                  color: white;
                }
              }
            }
          }
          .mockup-box {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            min-height: 434px;
            min-width: 200px;
            max-width: 470px;
            max-height: 938px;
            width: 470px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            overflow: hidden;

            img {
              width: 470px;
              height: auto;
              min-height: 434px;
              min-width: 200px;
              max-width: 470px;
              max-height: 938px;
              z-index: 99;
            }
          }
        }
      }
    }
    .footer {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 30%;
      height: 30vh;
    }
  }
  #last.small-desktop {
    .last-body {
      height: 80%;
      height: 80vh;
    }
    .footer {
      height: 20%;
      height: 20vh;
    }
    .last-right {
      .ramhee-msg {
        font-size: 0.9em !important;
      }
    }
    .answer-box {
      bottom: 30% !important;
      .answer {
        font-size: 0.9em !important;
      }
    }
  }
  #last.mini-desktop {
    .last-right {
      .ramhee-msg {
        font-size: 0.8em !important;
      }
    }
    .last-body {
      height: 80%;
      height: 80vh;
    }
    .footer {
      height: 20%;
      height: 20vh;
    }
    .answer-box {
      bottom: 30% !important;
      .answer {
        font-size: 0.8em !important;
      }
    }
  }
</style>
